import { Container, Grid, makeStyles, Paper, Typography } from '@material-ui/core'
import { FC, useEffect, useState, useRef } from 'react'
import useTranslate from '../i18n/useTranslate'
import Form from '../component/um/settingREC/form'
import { useHistory } from 'react-router-dom'
import Dialog, { DialogType } from '../control/dialog/dialog'

import useAuthenStore from '../stores/authen/authenStore'
import { useSettingREC, PostSettingRECType } from '../services/um/useSettingREC'
import usePreferanceProfile, { FormProps } from '../services/um/usePreferenceProfile'
import { FormApi } from 'final-form'

interface SettingRECAddProps {}
export type FormType = {
    nameTH: string | null
    nameEN: string | null
    recID: string | null
    addressTH: string | null
    addressEN: string | null
    telephone: string | null
    email: string | null

    headerCertificateEN: string | null
    headerCertificateTH: string | null
    headerMemorandumEN: string | null
    headerMemorandumTH: string | null
    organizationEN: string | null
    organizationTH: string | null
}

const SettingRECAdd: FC<SettingRECAddProps> = ({}) => {
    const classes = useStyle()
    const translate = useTranslate()
    const history = useHistory()
    const authenStore = useAuthenStore()
    const [configDialog, setConfigDialog] =
        useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogTwoRef = useRef<Record<string, Function>>()
    const refForm = useRef<FormApi<FormType, Partial<FormType>>>()
    const { potSettingREC, getMasterRECByID } = useSettingREC()

    let initialValues: FormType = {
        nameTH: null,
        nameEN: null,
        recID: null,
        addressTH: null,
        addressEN: null,
        telephone: null,
        email: null,

        headerCertificateEN: null,
        headerCertificateTH: null,
        headerMemorandumEN: null,
        headerMemorandumTH: null,
        organizationEN: null,
        organizationTH: null,
    }

    const onSubmit = async (value: FormType) => {
        setConfigDialog({
            title: `${translate.get('UM.SETTINGREC.MESSAGE.HEADER')}`,
            content: `${translate.get('UM.SETTINGREC.MESSAGE.CONFIRM')}`,
            type: 'alert-confirm',
            onClickConfirm: () => onSave(value),
        })

        dialogTwoRef.current?.openDialog()
    }

    const onSave = async (value: FormType) => {
        let values = {
            nameTH: value.nameTH || null,
            nameEN: value.nameEN || null,
            recID: String(value.recID) || null,
            userID: authenStore.profile.userId ?? 0,
            addressTH: value?.addressTH || null,
            addressEN: value?.addressEN || null,
            telephone: value?.telephone || null,
            email: value?.email || null,

            headerCertificateEN: value?.headerCertificateEN || null,
            headerCertificateTH: value?.headerCertificateTH || null,
            headerMemorandumEN: value?.headerMemorandumEN || null,
            headerMemorandumTH: value?.headerMemorandumTH || null,
            organizationEN: value?.organizationEN || null,
            organizationTH: value?.organizationTH || null,
        }

        const data = await potSettingREC(values)

        if (data.message === 'duplicated') {
            setConfigDialog({
                title: `${translate.get('UM.SETTINGREC.MESSAGE.HEADER')}`,
                content: `${translate.get('UM.SETTINGREC.MESSAGE.DUPLICATED')}`,
                type: 'alert-message',
            })
            dialogTwoRef.current?.openDialog()
        }

        if (data.id) {
            setConfigDialog({
                title: `${translate.get('UM.SETTINGREC.MESSAGE.HEADER')}`,
                content: `${translate.get('UM.SETTINGREC.MESSAGE.SUCCESS')}`,
                type: 'alert-message',
                onAfterClose: () => history.push('/settingREC'),
            })
            dialogTwoRef.current?.openDialog()
        }
    }

    const onChangeREC = async (recID: number) => {
        if (recID) {
            const res = await getMasterRECByID(recID)
            if (refForm.current) {
                //Allows batch updates by silencing notifications while the fn is running.
                refForm.current.batch(() => {
                    refForm.current?.change('headerCertificateEN', res?.headerCertificateEN ?? null)
                    refForm.current?.change('headerCertificateTH', res?.headerCertificateTH ?? null)
                    refForm.current?.change('headerMemorandumEN', res?.headerMemorandumEN ?? null)
                    refForm.current?.change('headerMemorandumTH', res?.headerMemorandumTH ?? null)
                    refForm.current?.change('organizationEN', res?.organizationEN ?? null)
                    refForm.current?.change('organizationTH', res?.organizationTH ?? null)
                })
            }
        }
    }

    const onBack = () => {
        history.goBack()
    }

    const onRefDialogTwo = (func: Record<string, Function>) => {
        dialogTwoRef.current = func
    }

    const onRefForm = (form: FormApi<FormType, Partial<FormType>>) => {
        refForm.current = form
    }

    return (
        <Container maxWidth="lg">
            <Typography variant="h5" style={{ fontWeight: 'bold', marginBottom: '20px' }}>
                {translate.get('UM.SETTINGREC.ADD.HEADER')}
            </Typography>
            <Paper className={classes.paper}>
                <Form
                    onRefForm={onRefForm}
                    onClickBack={onBack}
                    initialValues={initialValues}
                    onSubmit={onSubmit}
                    onChangeREC={onChangeREC}
                />
            </Paper>
            <Dialog onRef={onRefDialogTwo} {...configDialog} />
        </Container>
    )
}
export default SettingRECAdd
const useStyle = makeStyles((theme) => ({
    container: {
        width: '100%',
    },
    paper: {
        width: '100%',
        padding: '20px',
        [theme.breakpoints.down('sm')]: {
            backgroundColor: 'unset',
            boxShadow: 'unset',
            margin: '0px',
        },
    },
}))
